import React, { Fragment, useEffect, useRef, useState } from 'react';
import { CodingConstants, UIConstants } from '@constants';
import { useDetectOutsideClick } from '@hooks/useDetectOutsideClick';
import { Bar, BarWrapper, CloseIcon, MenuWrapper, Container, EmptyWrapper } from './Icons.styled';
import MenuOptions from '@components/MenuOptions/MenuOptions';
import RoundIcon from './RoundIcon';
import { HeaderProps, MainMenuOptions } from '@types';
import { useSelector } from 'react-redux';
import { selectedAccountLoanType } from '@store/selectors/widgets.selectors';
import { getmenuOptions } from '@utils/filterMenuOptions';

const HamBurgerIcon: React.FC<HeaderProps> = ({ menuOptions, content, loanType, name, isActive, setIsActive }) => {
    const { closeIconWhite } = UIConstants;
    const { servicingLoanType, inProgressLoanType, servicingType } = CodingConstants;

    const toggleMenu = () => setIsActive(!isActive);
    const accountLoanType = useSelector(selectedAccountLoanType);
    const servicingLoan = content === servicingLoanType ? true : false;
    const [mainMenuOptions, setMainMenuOptions] = useState([]);

    useEffect(() => {
        const filteredOptions = getmenuOptions(menuOptions, content, accountLoanType);
        setMainMenuOptions(filteredOptions);
    }, [content, menuOptions, accountLoanType]);

    const handleClose = () => {
        setIsActive(false);
    };
    document.getElementById('contentContainer')?.addEventListener('click', () => setIsActive(false));
    return (
        <>
            <BarWrapper data-testid="hamburgerIcon" onClick={toggleMenu}>
                <Bar />
                <Bar />
                <Bar />
            </BarWrapper>

            {isActive && (
                <Container>
                    <MenuWrapper>
                        <CloseIcon data-testid="closeSideMenu" src={closeIconWhite} alt="close" onClick={handleClose} />

                        {mainMenuOptions.map(menu => (
                            <Fragment key={menu.id}>
                                {servicingLoan && (
                                    <>
                                        {menu.id === 'Loan_Information' && (
                                            <MenuOptions
                                                heading={menu.name}
                                                menuOptions={menu.subMenuOptions}
                                                loanType={loanType}
                                                subMenuClick={handleClose}
                                            />
                                        )}
                                        {menu.id === 'Payment_Center' && (
                                            <MenuOptions heading={menu.name} menuOptions={menu.subMenuOptions} subMenuClick={handleClose} />
                                        )}
                                        {menu.id === 'Document' && (
                                            <MenuOptions heading={menu.name} menuOptions={menu.subMenuOptions} subMenuClick={handleClose} />
                                        )}
                                    </>
                                )}
                                {menu.id === 'Support' && (
                                    <MenuOptions
                                        heading={menu.name}
                                        menuOptions={menu.subMenuOptions}
                                        loanType={loanType}
                                        subMenuClick={handleClose}
                                    />
                                )}
                                {menu.id === 'Profile' && <RoundIcon userName={name} menuOptions={menu.subMenuOptions} />}
                                {menu.id === 'logout_url' && <MenuOptions heading={menu.name} url={menu.url} />}
                            </Fragment>
                        ))}
                    </MenuWrapper>
                    <EmptyWrapper />
                </Container>
            )}
        </>
    );
};

export default React.memo(HamBurgerIcon);
